//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";

export default {
	name: 'Cards',
	data() {
		return {
			
		}
	},
	computed: {
		...mapGetters(["socialData"]),
		posts() {
			return [this.socialData.posts.items[0], this.socialData.posts.items[1]];
		},
	},
	methods: {
		daysSincePosted(timeString) {
			let dateOfPost = new Date(timeString);
			let today = new Date();
			let diffInTime = today.getTime() - dateOfPost.getTime();
			let diffInDays = diffInTime / (1000*60*60*24);
			return Math.ceil(diffInDays);
		},
		iconClass(post) {
			return ["blue-icon-" + post.source.source.toLowerCase()];
		},
		imageExists(imageUrl){
			if (imageUrl && imageUrl.length > 0) {
				var http = new XMLHttpRequest();
				http.open('HEAD', imageUrl, false);
				if (http.status == 200) return false;
				http.send();
				return !http.status.toString().startsWith("4");
			}
		},
		interactionClass(post) {
			if (post.source.source.toLowerCase().includes("facebook") || post.source.source.toLowerCase().includes("youtube")) {
				return "blue-icon-like";
			} else {
				return "blue-icon-heart";
			}
		}
	},
	mounted() {
		
	}
}
